import { InjectionToken } from '@angular/core';

export const SIM_TABLE = new InjectionToken<any>('SIM_TABLE');

/** “SimTextColumn”的可配置选项 */
export interface TextColumnOptions<T> {
  /**
   * 如果未提供标题文本，则根据列名提供标题文本的默认函数。
   */
  defaultHeaderTextTransform?: (name: string) => string;

  /** 未提供数据访问器时使用的默认数据访问器 */
  defaultDataAccessor?: (data: T, name: string) => string;
}

/** 可用于指定文本列选项的注入标记 */
export const SIM_TEXT_COLUMN_OPTIONS = new InjectionToken<TextColumnOptions<any>>('SIM_TEXT_COLUMN_OPTIONS');

export const TABLE_LAYOUT_STRATEGY = new InjectionToken<any>('_TableLayoutStrategy');
